var _style, _defs, _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgrWaves(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1443 3005",
    style: {
      enableBackground: "new 0 0 1443 3005"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_2_);fill:#17202A;}\n\t.st1{clip-path:url(#SVGID_2_);}\n\t.st2{opacity:0.3;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_3_);}\n\t.st3{opacity:0.15;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_4_);}\n\t.st4{opacity:0.15;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_5_);}\n\t.st5{opacity:0.3;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_6_);}\n\t.st6{opacity:0.15;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_7_);}\n\t.st7{opacity:0.15;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_8_);}\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: -2,
    y: 0.5,
    width: 1447,
    height: 3004
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: 0.5,
    className: "st0",
    width: 1447,
    height: 3004
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 664.6707,
    y1: 2858.928,
    x2: 1192.1793,
    y2: 1556.3875
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0969,
    style: {
      stopColor: "#803D25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#17202A"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1071.86,1311.59c-283.72-70.15-581.03,89.18-656.14,337.33c-82.87,273.82,196.64,385.58,302.39,380.96 c134.47-5.88,345.46-23.87,434.98,124.8c137.37,228.16,299.68,341.66,431.47,206.16c119.95-123.34,98.71-330.37,57.79-475.22 C1577.67,1656.74,1355.58,1381.74,1071.86,1311.59z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 170.7602,
    y1: 263.2878,
    x2: 168.327,
    y2: 1268.1858
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#305299"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4107,
    style: {
      stopColor: "#253D6A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#17202A"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-325.08,1091.15c-211.2-202.02-235.91-538.42-66.58-734.76c186.84-216.65,430.93-40.47,483.67,51.31 C159.08,524.4,256.9,712.21,430.39,708.17c266.25-6.21,449.04,70.07,405.19,253.93c-39.91,167.36-226.11,260.31-370.35,303.33 C237.31,1333.42-113.87,1293.17-325.08,1091.15z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 163.7602,
    y1: 1782.2878,
    x2: 161.327,
    y2: 2787.1858
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#305299"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4107,
    style: {
      stopColor: "#253D6A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#17202A"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-332.08,2610.15c-211.2-202.02-235.91-538.42-66.58-734.76c186.84-216.65,430.93-40.47,483.67,51.31 c67.06,116.71,164.88,304.51,338.37,300.47c266.25-6.21,449.04,70.07,405.19,253.93c-39.91,167.36-226.11,260.31-370.35,303.33 C230.31,2852.42-120.87,2812.17-332.08,2610.15z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 926.3088,
    y1: -571.9827,
    x2: 681.882,
    y2: 634.3817
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0969,
    style: {
      stopColor: "#803D25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#17202A"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M819.5,617.19C533.51,677.41,241.93,507.83,175.52,257.2C102.23-19.34,385.47-121.29,491-112.99 c134.19,10.56,344.42,35.89,439.06-109.57c145.23-223.24,311.41-331.02,438.39-191c115.58,127.45,87.14,333.61,41.2,476.94 C1337.03,289.87,1105.5,556.97,819.5,617.19z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 416.9434,
    y1: -585.1299,
    x2: 944.452,
    y2: -1887.6703,
    gradientTransform: "matrix(0.9987 -0.0512 -0.0512 -0.9987 175.4583 1814.6637)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0969,
    style: {
      stopColor: "#574B37"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#17202A"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M988.96,3647.08c-279.75,84.6-584.84-59.28-672.56-303.26c-96.8-269.22,176.62-395.15,282.47-395.96 c134.6-1.02,346.23,6.14,428.01-146.93c125.49-234.9,281.78-356.57,420.33-228c126.12,117.03,115.52,324.88,82.06,471.63 C1476.41,3276.46,1268.71,3562.48,988.96,3647.08z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 1958.6748,
    y1: 1032.9209,
    x2: 1174.1437,
    y2: 260.2169
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#574B37"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#17202A"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1777.07,1136.64c-231.94,177.82-568.17,150.79-736.3-46.58c-185.52-217.78,25.91-432.05,124.68-470.14 c125.59-48.42,326.15-116.37,348.69-288.44c34.59-264.07,137.92-433.04,312.92-361.59c159.29,65.03,222.67,263.26,243.12,412.38 C2102.5,617.92,2009.01,958.81,1777.07,1136.64z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgrWaves);
export default __webpack_public_path__ + "static/media/bgr_waves.9493c27c8cfcf812374e77d4d0bc2bb5.svg";
export { ForwardRef as ReactComponent };